import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
export class VerificacaoSegurancaIdentificacaoComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.cpf = new EventEmitter();
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.buildForm();
            this.onChangeCpf();
        });
    }
    buildForm() {
        this.form = this.formBuilder.group({
            cpf: ['', Validators.required],
        });
    }
    onChangeCpf() {
        this.form.get('cpf').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((cpf) => {
            if (cpf && cpf.length === 11) {
                this.cpf.emit(cpf);
            }
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
